import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewLogs = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_14357_48086)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M23.7472 4.89356L19.0599 0.205969C18.928 0.0740625 18.7492 0 18.5627 0H7.78125C6.61814 0 5.67188 0.946266 5.67188 2.10938V11.383C2.51222 11.7339 0.046875 14.4202 0.046875 17.6719C0.046875 21.1612 2.88567 24 6.375 24H21.8438C23.0069 24 23.9531 23.0537 23.9531 21.8906V5.39077C23.9531 5.20425 23.8791 5.02547 23.7472 4.89356ZM19.2656 2.40061L21.5525 4.6875H19.2656V2.40061ZM1.45312 17.6719C1.45312 14.958 3.66108 12.75 6.375 12.75C9.08892 12.75 11.2969 14.958 11.2969 17.6719C11.2969 20.3858 9.08892 22.5938 6.375 22.5938C3.66108 22.5938 1.45312 20.3858 1.45312 17.6719ZM21.8438 22.5938H10.3476C11.6115 21.5716 12.4752 20.0738 12.6639 18.375H19.9688C20.3571 18.375 20.6719 18.0602 20.6719 17.6719C20.6719 17.2836 20.3571 16.9688 19.9688 16.9688H12.6638C12.5492 15.9366 12.1855 14.9785 11.6341 14.1562H19.9688C20.3571 14.1562 20.6719 13.8414 20.6719 13.4531C20.6719 13.0648 20.3571 12.75 19.9688 12.75H10.3476C9.43256 12.01 8.30803 11.5196 7.07812 11.383V2.10938C7.07812 1.72167 7.39355 1.40625 7.78125 1.40625H17.8594V5.39062C17.8594 5.77894 18.1742 6.09375 18.5625 6.09375H22.5469V21.8906C22.5469 22.2783 22.2315 22.5938 21.8438 22.5938Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.9688 8.53125H9.65625C9.26794 8.53125 8.95312 8.84606 8.95312 9.23438C8.95312 9.62269 9.26794 9.9375 9.65625 9.9375H19.9688C20.3571 9.9375 20.6719 9.62269 20.6719 9.23438C20.6719 8.84606 20.3571 8.53125 19.9688 8.53125Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.25 18.375C8.63831 18.375 8.95312 18.0602 8.95312 17.6719C8.95312 17.2836 8.63831 16.9688 8.25 16.9688H7.07812V14.8594C7.07812 14.4711 6.76331 14.1562 6.375 14.1562C5.98669 14.1562 5.67188 14.4711 5.67188 14.8594V17.6719C5.67188 18.0602 5.98669 18.375 6.375 18.375H8.25Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_14357_48086",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgViewLogs;
